<template>
  <div class="lb-3n-ts-03">
    <div class="zxlb-1n-ts-01-list">
      <dl v-for="(item, index) in news" :key="index">
        <dt>
          <router-link :to="item.classifyid | findpy(curPath, item.id)" target="_blank"><img :alt="item.title" :src="item.article_img" :title="item.title" /></router-link>
        </dt>
        <dd>
          <h4>
            <router-link :to="item.classifyid | findpy(curPath, item.id)" target="_blank" :title="item.title">{{ item.title }}</router-link>
          </h4>
          <div class="zxlb-1n-ts-01-list-desc">{{ item.introduce }}</div>
          <div class="zxlb-1n-ts-01-list-deta"><router-link :to="item.classifyid | findpy(curPath, item.id)" target="_blank" :title="item.title">了解详情</router-link></div>
        </dd>
      </dl>
    </div>
    <div class="fenye">
      <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        layout="total, prev, pager, next, jumper"
        :page-sizes="[12, 24, 36]"
        :hide-on-single-page="total < listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/pagination';
import utils from '@/api/to_py.js';
export default {
  data() {
    return {
      news: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      curPath: this.$route.path.split('/')[2]
    };
  },
  components: {
    Pagination
  },
  mounted() {
    // console.log(this.$route);
    this.getList();
  },
  methods: {
    getList() {
      this.$post('/Article/article_list', {
        classifyid: 21,
        page: this.listQuery.page,
        limit: this.listQuery.limit
      }).then(response => {
        // console.log(response.data);
        this.news = response.data || [];
        this.total = response.count;
      });
    }
  },
  filters: {
    findpy(id, classifyname, idd) {
      return '/newsdetail/' + utils.ConvertPinyin(classifyname) + '/1' + idd + '.html';
    }
  }
};
</script>

<style lang="less">
.zxlb-1n-ts-01-list {
  dl {
    border: 1px solid rgba(223, 223, 223, 1);
    width: 100%;
    margin-bottom: 15px;
    padding: 22px 0 22px;
    background: #fff;
    display: inline-block;
    &:hover {
      border-color: rgba(19, 181, 179, 1);
      h4 a {
        color: rgba(19, 181, 179, 1);
      }
      .zxlb-1n-ts-01-list-deta {
        background: rgba(19, 181, 179, 1);
        border-color: rgba(19, 181, 179, 1);
      }
      .zxlb-1n-ts-01-list-deta a {
        color: #fff;
      }
    }
  }
  dt {
    width: 22.67%;
    float: left;
    margin-left: 22px;
    margin-right: 5.5%;
    img {
      width: 100%;
      margin: 0 auto;
      height: 200px;
      display: block;
    }
  }
  dd {
    width: 67%;
    float: left;
    h4 {
      height: 40px;
      font-weight: bold;
      font-size: 19px;
      color: rgba(75, 74, 74, 1);
      line-height: 40px;
      margin-bottom: 5px;
      a {
        display: block;
        color: rgba(75, 74, 74, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .zxlb-1n-ts-01-list-desc {
      max-height: 96px;
      font-size: 15px;
      line-height: 24px;
      color: rgba(121, 121, 121, 1);
      margin-bottom: 15px;
      overflow: hidden;
    }
    .zxlb-1n-ts-01-list-deta {
      float: right;
      width: 134px;
      height: 40px;
      display: inline-block;
      border: 1px solid rgba(172, 172, 172, 1);
      font-size: 15px;
      line-height: 40px;
      text-align: center;
      color: rgba(121, 121, 121, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/changjianwenti.vue